<template>

  <div class="bg-gray-200 min-h-screen relative pb-12">

      <main class="flex-grow pt-16">

        <div class="mx-auto pl-20 pr-20 pt-20 pb-10 text-center">
          <font-awesome-icon :icon="['fas', 'circle-exclamation']" class="pb-5 text-6xl text-red-700"/>
          <div class="text-lg md:text-2xl">¡Atención!</div>
          <div class="text-lg md:text-2xl">La página no fue encontrada</div>
        </div>

      </main>

  </div>

</template>
